export default {
	visitorMode: true
}

